import { useState } from 'react';
import { toast } from '@/components/ui/toaster.jsx';
import { stateTailModel, confirmTailModel } from '@/services/aircraft-identity.service.js';
import ModelSearch from './ModelSearch.jsx';

const btn = 'inline-flex items-center rounded-[5px] border border-accent bg-accent px-2.5 py-1 text-[12px] text-white hover:brightness-110 disabled:opacity-50';
const errText = (e) => e?.body?.error || e?.message || 'failed';

// David answers the data plate for one aircraft (MAKE-MODEL-TIME-SPEC section 1): a match the registry offers, or any
// AMIN model by name when the plate says something else. His answer is the tail-level identity, recorded with who and
// when; it overrides the registry and the crosswalk for this aircraft only.
export function StateTailModel({ tail, candidates = [], offered = null, onDone }) {
  const [pick, setPick] = useState(offered || (candidates.length === 1 ? candidates[0] : null));
  const [saving, setSaving] = useState(false);
  const [searching, setSearching] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const out = await stateTailModel({ registration: tail, model_key: pick.model_key });
      toast.success(`${out.answer.registration} is ${out.answer.label}`);
      onDone?.(out);
    } catch (e) { toast.error(`Not stated: ${errText(e)}`); } finally { setSaving(false); }
  };
  const options = [...(offered ? [offered] : []), ...candidates.filter((c) => !offered || c.model_key !== offered.model_key)];
  return (
    <div className="space-y-1.5">
      {options.map((c) => (
        <label key={c.model_key} className="block text-[13px]"><input type="radio" checked={pick?.model_key === c.model_key} onChange={() => setPick(c)} /> {c.label}</label>
      ))}
      {pick && !options.some((c) => c.model_key === pick.model_key) ? <div className="text-[13px]">Picked: {pick.label}</div> : null}
      {searching ? <ModelSearch autoFocus onPick={(m) => { setPick(m); setSearching(false); }} /> : (
        <button type="button" className="text-[12px] text-accent underline" onClick={() => setSearching(true)}>The plate says another model</button>
      )}
      <div><button type="button" className={btn} disabled={!pick || saving} onClick={save}>{saving ? 'Saving' : pick ? `State ${tail} is ${pick.label}` : `Pick ${tail}'s model`}</button></div>
    </div>
  );
}

// David confirms the applicant's data plate answer (section 8 answer 2: flagged for his confirmation before quoting).
export function ConfirmTailModel({ tail, answer, onDone }) {
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await confirmTailModel({ registration: tail, model_key: answer.model_key });
      toast.success(`${tail}: the applicant's answer (${answer.label}) is confirmed`);
      onDone?.();
    } catch (e) { toast.error(`Not confirmed: ${errText(e)}`); } finally { setSaving(false); }
  };
  return <button type="button" className={btn} disabled={saving} onClick={save}>{saving ? 'Confirming' : `Confirm ${tail} is ${answer.label}`}</button>;
}
